import assign from 'lodash.assign';
export class ResponseValue {
    constructor(init) {
        assign(this, init);
    }
    id;
    description;
    responseAmount;
    responseCode;
    responseDate;
    responseTime;
    responseID;
    responseIndicator;
    responseMeasure;
    responseNumeric;
    responseQuantity;
    responseURI;
}
